import { EModeCategory } from '../types'
import {
  EModeCategoryId,
  EModeCategoryName,
  eModeCategoryIdToName,
} from '@/features/sparklend/common/data/market-info/emode'
import { MarketInfo } from '@/features/sparklend/common/data/market-info/marketInfo'

export function getEModeCategories(
  marketInfo: MarketInfo,
  selectedEModeCategoryId: EModeCategoryId,
  setSelectedEModeCategoryId: (id: EModeCategoryId) => void,
): Record<EModeCategoryName, EModeCategory> {
  const reserves = marketInfo.userPositions.map((position) => position.reserve)

  const currentEModeCategoryId = marketInfo.userConfiguration.eModeState.enabled
    ? marketInfo.userConfiguration.eModeState.category.id
    : 0

  function getEModeCategory(eModeCategoryId: EModeCategoryId): EModeCategory {
    return {
      name: eModeCategoryIdToName[eModeCategoryId],
      tokens: reserves
        .filter((reserve) => (eModeCategoryId === 0 ? true : eModeCategoryId === reserve.eModeCategory?.id))
        .map((reserve) => reserve.token),
      isActive: currentEModeCategoryId === eModeCategoryId,
      isSelected: selectedEModeCategoryId === eModeCategoryId,
      onSelect: () => setSelectedEModeCategoryId(eModeCategoryId),
    }
  }

  return {
    'No E-Mode': getEModeCategory(0),
    'ETH Correlated': getEModeCategory(1),
    'BTC Correlated': getEModeCategory(3),
    Stablecoins: getEModeCategory(2),
  }
}
